module.exports = __webpack_public_path__ + "img/content.a15bc2d6.png";